







import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class CursorCrossHair extends Vue {
    @Prop({ required: true, type: Number }) x!: number
    @Prop({ required: true, type: Number }) y!: number
    @Prop({ required: true, type: Number }) height!: number
    @Prop({ required: true, type: Boolean }) visible!: boolean
}
